import React from "react";

function AboutOverlay({ enabled, setEnabled }) {
  return (
    <div className={`w-full ${enabled ? "" : "hidden"}`}>
      <div
        onClick={() => setEnabled(false)}
        className="fixed w-full h-full bg-black opacity-80 z-40"
      >
        </div>
        <div
        onClick={() => setEnabled(false)}
        className="fixed w-full h-full  opacity-100 z-40"
      >
       
      <div className=" relative mx-auto mt-5 p-5 bg-white shadow-md z-100 w-4/5 overflow-y-auto opacity-100 " style={{height:"90vh"}}>
        <button
          className="absolute top-5 right-5 text-xl font-bold"
          onClick={() => setEnabled(false)}
        >
          X
        </button>
        <h1 className="font-bold mb-3 text-xl">About Cov2Tree</h1>
        This website allows you to explore a phylogenetic tree with more than a
        million SARS-Cov-2 sequences, sequenced by researchers around the world.
        The interface was made by{" "}
        <a className="text-blue-700 underline" href="http://theo.io/">
          Theo Sanderson
        </a>{" "}
        using a custom-developed open-source library called{" "}
        <a
          href="http://github.com/theosanderson/taxodium"
          className="text-blue-700 underline"
        >
          {" "}
          Taxodium
        </a>
        .<h1 className="font-bold mb-3 text-xl mt-6">The sequences</h1>
        <p>
          This tree displays sequences generated by scientists all over the
          world. The sequences are sourced from GenBank (i.e. the INSDC
          databases), the China National Center for Bioinformation, and from
          COG-UK. They are collated{" "}
          <a
            className="text-blue-700 underline"
            href="http://hgdownload.soe.ucsc.edu/goldenPath/wuhCor1/UShER_SARS-CoV-2//"
          >
            here
          </a>{" "}
          by Angie Hinrichs and others at UCSC.
        </p>
        <p>
          This website would be empty but for the hard work of all these
          researchers, and their openness in submitting their work to public
          databases, and we gratefully acknowledge this.
        </p>
        <h1 className="font-bold mb-3 text-xl mt-6">The tree</h1>
        <p>
          The tree shown here is produced by the UCSC team, and made available{" "}
          <a
            className="text-blue-700 underline"
            href="http://hgdownload.soe.ucsc.edu/goldenPath/wuhCor1/UShER_SARS-CoV-2//"
          >
            here
          </a>
          . It is derived from releases of Rob Lanfear's{" "}
          <a
            className="text-blue-700 underline"
            href="https://github.com/roblanf/sarscov2phylo"
          >
            sarscov2phylo
          </a>
          , pruned to include only public sequences aggregated from GenBank,
          COG-UK, and the China National Center for Bioinformation. The tree has
          been re-rooted to Wuhan/Hu-1 (GenBank MN908947.3, RefSeq NC_045512.2),
          and nodes with no associated mutations have been collapsed. Sequences
          released after the final sarscov2phylo release (Nov. 13, 2020) have
          been added to the tree using{" "}
          <a
            className="text-blue-700 underline"
            href="https://github.com/yatisht/usher"
          >
            UShER
          </a>
          , developed by Yatish Turakhia. UShER development and tree inference
          was done in Russ Corbett-Detig and David Haussler's groups at the UCSC
          Genomics Institute. It is described here only for completeness. UCSC
          provide metadata with the sequences, including lineages called by{" "}
          <a
            className="text-blue-700 underline"
            href="https://www.pango.network/"
          >
            Pangolin
          </a>
          .
        </p>
        <h1 className="font-bold mb-3 text-xl mt-4">Citations</h1>
        <div className="text-sm">
        <p>
          Lanfear, Rob (2020). A global phylogeny of SARS-CoV-2 sequences from
          GISAID. Zenodo DOI: 10.5281/zenodo.3958883
        </p>
        <p>
          Turakhia et al. (2021). Ultrafast Sample Placement on Existing Trees
          (UShER) Empowers Real-Time Phylogenetics for the SARS-CoV-2 Pandemic.
        </p>
        <p>
          Rambaut et al. (2020). A dynamic nomenclature proposal for SARS-CoV-2
          lineages to assist genomic epidemiology.
        </p></div>
        <h1 className="font-bold mb-3 text-xl mt-4">Related tools</h1>
        <div className="text-sm">
        <p>
          You can also explore large phylogenies using{" "}
          <a className="text-blue-700 underline" href="https://pando.tools">
            Pando
          </a>
          ,{" "}
          <a className="text-blue-700 underline" href="https://microreact.org/">
            Microreact
          </a>
          , and sampled phylogenies on{" "}
          <a className="text-blue-700 underline" href="https://nextstrain.org/">
            NextStrain
          </a>
          .
        </p></div>
      </div>
       {" "}
      </div>
    </div>
  );
}

export default AboutOverlay;
